import { NgModule } from '@angular/core';

import { CookiesService } from './service/cookies.service';

@NgModule({
  imports: [],
  declarations: [],
  providers: [CookiesService],
  exports: [],
})
export class CookiesModule {}
